/* eslint-disable */
import React, { useState } from 'react';
import './GetPower.css';
import '../../../components/buttons/mainBtn.css';
import { Col } from 'react-bootstrap';
import { PowerMetricsColor } from '../../../components/globalStyles';
import { useTranslation } from 'react-i18next';
import ReactGA from 'react-ga';
import { ENV } from '../../../environment';
import { Button } from '../../../shared/ui';
import { formatOcppStopDetail } from './ocppStopMessage';

export default function CongratsFail({
  kWtCharged,
  carKwtKmRatio,
  chargeStatus,
  stationNumber,
  ocppStopReason,
  ocppErrorCode,
  ocppErrorInfo,
  ocppVendorErrorCode,
}) {
  const [modalOpen, setModalOpen] = useState();

  let finishBtn = 'mainBtn';
  let startBtnText = 'mainBtnText';

  const { t } = useTranslation();
  const ocppDetail = formatOcppStopDetail({ ocppErrorCode, ocppErrorInfo, ocppStopReason });
  const ocppTitle =
    ocppVendorErrorCode && String(ocppVendorErrorCode).trim() ? String(ocppVendorErrorCode).trim() : undefined;

  const openModal = () => {
    ReactGA.event({
      category: 'calibration',
      action: 'open calibration modal',
    });
    if (ENV === 'prod') {
      console.log('close');
    } else {
      setModalOpen(true);
    }
  };

  const styleModalBtn = ENV === 'prod' ? 'disableModalBtn' : `${finishBtn}`;

  const styleModalBtnText = ENV === 'prod' ? 'disableModalBtnText' : `${startBtnText}`;

  return (
    <div id="offlineStationContainer">
      <Col id="offlineStationBox" xs="auto" lg="auto" className="text-center">
        <PowerMetricsColor id="offlineStationCongratsTitle" className="finishTitle">
          {t('powerExceededError')}{' '}
        </PowerMetricsColor>
        {ocppDetail ? (
          <p className="session-result__ocpp-stop" title={ocppTitle}>
            {t('stationStoppedCharging', { detail: ocppDetail })}
          </p>
        ) : null}
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Button className={'mainBtn mainBtnText'} link={`/start?station=${stationNumber}`}>
            {t('startNew')}
          </Button>
        </div>
      </Col>
    </div>
  );
}
